import _styled6 from "styled-components";
import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import Spinner, { SpinnerSize } from '../spinner/Spinner';
import { basic, overlay, wrapper, modalStyle, loadingStyle, modalSavingSpinner, ModalSize } from './Modal.style';
import ModalBody from './ModalBody';
import ModalClose from './ModalClose';
import ModalContext from './ModalContext';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
export { ModalSize } from './Modal.style';
export { ModalCloseVariant } from './ModalClose';
export const Modal = _ref => {
  let {
    size = ModalSize.MEDIUM,
    open = false,
    loading = false,
    saving = false,
    fillAvailableHeight = false,
    height,
    onCloseHandler,
    children,
    dataRef = 'modal',
    ...rest
  } = _ref;
  const contextValue = React.useMemo(() => ({
    open,
    loading,
    saving,
    onCloseHandler
  }), [loading, onCloseHandler, open, saving]);
  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    $open: open,
    "data-ref": dataRef
  }, rest), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $open: open,
    role: "button",
    onClick: onCloseHandler || undefined,
    "data-ref": `${dataRef}-overlay-box`
  }), loading && /*#__PURE__*/React.createElement(_StyledDiv3, {
    "data-ref": `${dataRef}-loading-box`
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: SpinnerSize.BIG,
    color: "neutrals.lightest"
  })), /*#__PURE__*/React.createElement(_StyledDiv4, {
    $size: size,
    $loading: loading,
    $open: open
  }, /*#__PURE__*/React.createElement(_StyledDiv5, {
    $fillAvailableHeight: fillAvailableHeight,
    $height: height,
    $size: size
  }, saving && /*#__PURE__*/React.createElement(_StyledDiv6, null, /*#__PURE__*/React.createElement(Spinner, {
    size: SpinnerSize.BIG,
    color: "neutrals.light"
  })), children))));
};
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.Close = ModalClose;
export default Modal;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Modal___StyledDiv",
  componentId: "sc-vqdw3u-0"
})(["", ""], basic);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "Modal___StyledDiv2",
  componentId: "sc-vqdw3u-1"
})(["", ""], overlay);
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "Modal___StyledDiv3",
  componentId: "sc-vqdw3u-2"
})(["", ""], loadingStyle);
var _StyledDiv4 = _styled("div").withConfig({
  displayName: "Modal___StyledDiv4",
  componentId: "sc-vqdw3u-3"
})(["", ""], wrapper);
var _StyledDiv5 = _styled("div").withConfig({
  displayName: "Modal___StyledDiv5",
  componentId: "sc-vqdw3u-4"
})(["", ""], modalStyle);
var _StyledDiv6 = _styled("div").withConfig({
  displayName: "Modal___StyledDiv6",
  componentId: "sc-vqdw3u-5"
})(["", ""], modalSavingSpinner);
//# sourceMappingURL=Modal.js.map